import React from 'react'

import './css/spinner.css'
import Doted from './Doted'

const Loadingspinner = () => {
    return (
        <div className='container-fluid justify-content-center'>
            <div className="d-flex justify-content-center">
                <div className="loading-spinner">
                </div>
            </div><br />
            <div className="d-flex justify-content-center">
                <h5 className='p-2'>กำลังโหลด</h5>
                <div className="p-2"><Doted /></div>
                <div className="p-2"><Doted /></div>
                <div className="p-2"><Doted /></div>
                <div className="p-2"><Doted /></div>
            </div>
        </div>
    )
}

export default Loadingspinner